"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareDesc = exports.compare = void 0;
var compare = function (a, b) {
    if (a.A !== b.A) {
        return a.A - b.A;
    }
    else if (a.B !== b.B) {
        return a.B - b.B;
    }
    else {
        return a.C - b.C;
    }
};
exports.compare = compare;
var compareDesc = function (a, b) {
    return (0, exports.compare)(b, a);
};
exports.compareDesc = compareDesc;
